import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MatDialogContent } from '@angular/material/dialog';
import dayjs from 'dayjs';
import { CheckInService } from '../../../../services/check-in.service';
import { ToastService } from '../../../../services/toast.service';
import { ModalHeaderComponent } from '../../../molecules/modal/modal-header/modal-header.component';
import { NoEntriesPlaceholderComponent } from '../../../molecules/no-entries-placeholder/no-entries-placeholder.component';
import { PaginatorComponent } from '../../../molecules/paginator/paginator.component';
import { PaginatorIntervalTypeEnum } from '../../../molecules/paginator/paginator.enum';
import { LeaderBoardCoachEntryDTO } from '../../leader-board/leader-board.types';
import { ToastTypeEnum } from '../../toast/toast.type';

@Component({
  selector: 'app-modal-leader-board',
  imports: [
    ModalHeaderComponent,
    PaginatorComponent,
    MatDialogContent,
    NoEntriesPlaceholderComponent,
  ],
  templateUrl: './modal-leader-board.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalLeaderBoardComponent {
  private readonly checkInService = inject(CheckInService);
  private readonly toastService = inject(ToastService);

  protected PaginatorIntervalTypeEnum = PaginatorIntervalTypeEnum;
  readonly sortedLeaderBoard = computed(() =>
    this.leaderBoard().sort((a, b) => (a.checkInCount > b.checkInCount ? -1 : 1))
  );

  private readonly leaderBoard = signal<LeaderBoardCoachEntryDTO[]>([]);

  public fetchData(index: number, year: number): void {
    const start = dayjs().year(year).month(index).startOf('month');
    const end = dayjs().year(year).month(index).endOf('month');

    this.checkInService.getLeaderBoardCoach(start, end).subscribe({
      next: (response) => this.leaderBoard.set(response),
      error: () => this.toastService.addToast('Fehler beim Laden der Daten', ToastTypeEnum.ERROR),
    });
  }
}
